import api from "./api";

export const postPatient = (data: any) => {
  return api.post("/Patient/register", data);
};

export const seeNotification = (notificationId: number) => {
  return api.post(
    "/notification/seen",
    {},
    {
      params: {
        id: notificationId,
      },
    }
  );
};

export const postPatientHistory = (data: any) => {
  return api.post("/patient/history", data);
};

export const postStaff = (data: any) => {
  return api.post("/Staff", data);
};

export const postBranch = (data: any) => {
  return api.post("/Branch/create", data);
};

export const postTakenTreatment = (data: any) => {
  return api.post("/TakenTreatment", data);
};

export const postTreatment = (data: any) => {
  return api.post("/Treatment", data);
};

export const postTransaction = (data: any) => {
  return api.post("/Transaction", data);
};

export const postFee = (data: any) => {
  return api.post("/fee", data);
};

export const changeState = (data: any) => {
  return api.post("/ChangeRule", data);
};

export const postUser = (data: any) => {
  return api.post("/User/Register", data);
};

export const postSAAS = (data: any) => {
  return api.post("/User/registerSaas", data);
};

export const joinGroup = () => {
  return api.post("/toGroup");
};
